import React, {useState} from 'react';
import { Button, Badge, Modal } from 'react-bootstrap';
import { useContext } from 'react';
import SimpleContext from './../../context//SimpleContext';

const Counter = ({isSahmiyeh, Role, min, max, numUnit, unit, fresh, price, slug, name, stock, numSale, goodsRef, uniqueid}) => {

    const context = useContext(SimpleContext);
    const [num, setNum] = useState(0);
    const [RoleCheck, setRoleCheck] = useState(false);


    for (let i = 0; i < context.Maximum.length; i++) {

        if (context.Maximum[i].slug === slug) {
            max = context.Maximum[i].maximum;
        }
    }
   
    const increment = () => {
        if (stock === 0 || stock === numSale){
            context.HandelShowContentPage('11');
        }
        else if (Role !== "" && context.UseInFo.Role === "") {
            setRoleCheck(true)
        }
        else{
            context.handleAddProduct({min, max, name, slug, goodsRef, uniqueid, price, num:{num}, numUnit, numSale, unit})
            context.badgeNum(slug)
            setNum(context.PrdCount);
            if (max > num ){
                setNum(num + 1);
            }else{
                setNum(max)
            }
            if (num === max) {
                setNum(max)
                context.HandelShowContentPage('7')
            }
        }
    };
    
    const decrement = () => {
        // setNum(num - 1);
        if (min < num ){
            setNum(num - 1);
            context.handleRemoveProduct({min, max, name, slug, goodsRef, uniqueid, price, num:{num}, numUnit, numSale,unit})
        }else{
            setNum(0)
            context.handleDeleteItemFromSabad(slug)
        }
    };

    const existChecker = () => {
        let badge = 0;
        const ex = context.CartItems.filter(item => item.slug === slug)
        if (ex.length > 0) {
            return badge = parseInt(ex.map(i=>i.ProCount))
        }else{
            return badge = 0
        }
    }

    // const RoleCodeChecker = () => {
    //     let Check = "ok";
    //     if (Role !== "" && context.UseInFo.Role === "") {
    //         return Check ="notOK"
    //     }else if (Role !== "" && context.UseInFo.Role !== "") {
    //         return Check = "Ok"
    //     }
    // }
    // RoleCodeChecker()

    return ( 
        <div className="card-footer">
            {
                num > max-1 ?
                <Button
                variant="success"
                className="btn btn-sm plusbtn fa fa-plus"
                onClick={isSahmiyeh === 0?()=>context.HandelShowContentPage('7') : ()=>context.HandelShowContentPage('13')}
                />
                :
                <Button
                    variant="success"
                    className="btn btn-sm plusbtn fa fa-plus"
                    onClick={increment}
                />

            }
            {
                existChecker() > 0?
                    <>
                        <Badge className="badgbtn">
                            <p>
                                {existChecker()}{unit}<br/>
                                {numUnit}عددی
                            </p>
                        </Badge>
                        <Button
                            variant="success"
                            onClick={decrement}
                            className='minusbtn'>
                            <i className="fa fa-minus"></i>
                        </Button>
                    </>

                :
                    <Badge className="badgeZero">
                        <p>
                            0
                        </p>
                    </Badge>

            }
                
            <Modal
            show={RoleCheck}
            centered>
                <Modal.Body style={{width:"100%", color:"black"}} className="text-center p-3">
                    <p style={{margin:"0", fontSize:"17px", textAlign:"center"}}>
                    لطفا برای خرید این کالا کد نقش خود را به شماره 09198807264 اعلام نمایید.
                    <br/>
                    </p>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button variant="danger" style={{width:"100%"}} onClick={()=>setRoleCheck(false)}>بستن</Button>
                </Modal.Footer>
            </Modal>
            
        </div>
     );
}
 
export default React.memo(Counter);